import React, { useEffect, useState } from 'react';
import { UserInfosModel } from '../../models/user/UserInfosModel';
import AlertSaveModal from '../UserInfo/AlertSaveModal';
import { Alert, Box, Button, Grid, Snackbar, TextField, Typography } from '@mui/material';
import { useTranslationContext } from '../../hooks/translations/translationsProvider';
import { GREEN_LOGO, GREEN_MAIN, WHITE } from '../../theme/colors';
import TextFieldPasswordCustom from '../TextField/TextFieldPasswordCustom';
import { changePasswordRequest } from '../../hooks/actions/changePassword';
import { UpdateUserPasswordRequestModel } from '../../models/changePassword/changePassword';
import { useWaiter } from '../../hooks/waiter/WaiterProvider';
import PasswordToggleIcon from './PasswordToggleIcon';

const ChangePassword: React.FC = () => {
  const [userInfo, setUserInfo] = useState<UserInfosModel | null>(null);
  const [errorMsg, setErrorMsg] = useState<string>("");
  const [error, setError] = useState(false);

  const [showPopup, setShowPopup] = useState(false);
  
  const [password, setPassword]=useState<string>("");
  const [newPw, setNewlPW]=useState<string>("");
  const [confirmNewPw, setConfirmNewlPW]=useState<string>("");
  const [confirmNewPwErrorMsg, setConfirmNewlPWErrorMsg]=useState<string>("");
  const [confirmNewPwError, setConfirmNewlPWError]=useState<boolean>(false);
  const [authorizeChange, setAutorizeSave] = useState<boolean>(false);
  const {t} = useTranslationContext();
  const {setWaiterView} = useWaiter();

  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showPassword, setShowPassword] = useState(false); // toggle password (occhiolino)
  const [showPasswordConfirm, setShowPasswordConfirm] = useState(false); // toggle password (occhiolino)

  const regex:RegExp = /^(?=.*[a-zàèìòùáéíóúäëïöüßçñ])(?=.*[A-ZÀÈÌÒÙÁÉÍÓÚÄËÏÖÜÇÑ])(?=.*[0-9])(?=.*[!@#$%^&*()[\]{}\-_+=<>,.?/\\|])[^\s]+$/;
  const minPasswordLenght = 8;

  const handleChangePassword = async () => {
    const model:UpdateUserPasswordRequestModel={
      newPassword:newPw,
      oldPassword:password
    }

    try{
      setError(false);
      setErrorMsg("");
      setWaiterView(true);
      const resp = await changePasswordRequest(model);
      setWaiterView(false);

      setShowPopup(true); // apertura e chiusura del popup
      setTimeout(() => {
        setShowPopup(false);
      }, 10000);

      setPassword("");
      setNewlPW("");
      setConfirmNewlPW("")

    }catch(error:any){
      setWaiterView(false);
      setError(true);
      const errorMex =  error.data ||
                        error?.response?.data?.title || 
                        error?.response?.data?.message || 
                        error?.response?.data || 
                        error?.response || 
                        t("Errore durante la modifica dei dati")
      setErrorMsg(t(errorMex));
    }
  }

  useEffect(()=>{
    setAutorizeSave(false);
    if(newPw.length > 0){
      const pwLength = newPw.length >= minPasswordLenght;
      const regTest = regex.test(newPw);
      if(pwLength && regTest && newPw === confirmNewPw)
        setAutorizeSave(true);
    }
  },[newPw, confirmNewPw])

  return (
    <Box
      width='100%'
    >
      <Typography
          variant="h4"
          component="h1"
          gutterBottom
          sx={{
              mb: 8,
              mt:0,
              fontWeight: "bold",
              color: GREEN_MAIN
          }}
      >
          {t("Cambio Password")}
      </Typography>

      <form>
        <Box justifyItems='center'>
          <Grid container xs={12} md={4} spacing={0} paddingBottom='100px'>
              <TextFieldPasswordCustom
                label={t("Password Attuale")}
                value={password}
                errorText={t("Errore di inserimento nella password attuale")}
                onChange={(value:string) => setPassword(value)}
                showPassword={showCurrentPassword}
                setShowPassword={setShowCurrentPassword}
              />

              <TextFieldPasswordCustom
                label={t("Nuova Password")}
                regex={regex}
                value={newPw}
                errorText={t('Password non valida. Deve contenere almeno 1 minuscola, 1 maiuscola, a carattere speciale, 1 numero zero spazi e avere almeno 8 caratteri')}
                onChange={(value:string) => {
                  setNewlPW(value);
                  // Rimuove l'errore di conferma quando le password coincidono durante la digitazione
                  if(value === confirmNewPw && confirmNewPwError){
                    setConfirmNewlPWError(false);
                    setConfirmNewlPWErrorMsg("");
                  }
                }}
                minPasswordLength={minPasswordLenght}
                showPassword={showPassword}
                setShowPassword={setShowPassword}
              />

              <TextField
                margin="normal"
                required
                fullWidth
                value={confirmNewPw}
                name={confirmNewPw}
                label={t("Conferma Nuova Password")}
                type={showPasswordConfirm ? "text" : "password"}
                id={confirmNewPw}
                onChange={(event) => {
                  const newValue = event.target.value;
                  setConfirmNewlPW(newValue);
                  // Rimuove l'errore quando le password coincidono durante la digitazione
                  if(newValue === newPw){
                    setConfirmNewlPWError(false);
                    setConfirmNewlPWErrorMsg("");
                  }
                }}
                onBlur={()=>{
                  if(confirmNewPw !== newPw){
                    setConfirmNewlPWError(true);
                    setConfirmNewlPWErrorMsg("Le password non coincidono");
                  } else {
                    // Rimuove l'errore quando le password coincidono
                    setConfirmNewlPWError(false);
                    setConfirmNewlPWErrorMsg("");
                  }
                }}
                onFocus={() => {
                  // Rimuove l'errore quando si mette il focus e le password coincidono
                  if(confirmNewPw === newPw && confirmNewPwError){
                    setConfirmNewlPWError(false);
                    setConfirmNewlPWErrorMsg("");
                  }
                }}
                error={confirmNewPwError}
                helperText={
                    confirmNewPwError ? t(confirmNewPwErrorMsg) : ""
                }
                InputProps={{
              endAdornment: (
                <PasswordToggleIcon
                  visible={showPasswordConfirm}
                  onToggle={() => setShowPasswordConfirm(prev => !prev)}
                  password={confirmNewPw}
                />
                  ),
                }}
                
              />
          </Grid>
        </Box>
      </form>

      {
        <Grid container justifyContent="center" alignItems="center">
          <Grid item xs={6} sm={4} md={2}>
            <Button variant="contained" color="info" onClick={()=>{handleChangePassword()}} sx={{
              margin:"10px 0 0 0",
              height: '35px',
              color:WHITE,
              backgroundColor: GREEN_LOGO,
              "&:hover": { backgroundColor: "darkgreen" },
              border: "1px solid " + GREEN_LOGO,
            }}
            disabled={!authorizeChange}
            >
              {t("Salva")}
            </Button>
          </Grid>
        </Grid>
      }

      {error && <>
          <Typography
            variant="body2" // Tipo di testo
            color="error"   // Colore rosso per il messaggio di errore
            sx={{
              maxHeight: '6.5em',        // Limite massimo di altezza per circa 5 righe (1.3em per linea)
              overflow: 'hidden',        // Nasconde l'overflow
              textOverflow: 'ellipsis',  // Aggiunge i puntini di sospensione se il testo è troppo lungo
              display: '-webkit-box',
              WebkitBoxOrient: 'vertical',
              WebkitLineClamp: 5,        // Limita il numero massimo di righe a 5
              lineHeight: '1.3em',       // Altezza della riga per calcolare il numero di righe
              wordWrap: 'break-word',    // Va a capo automaticamente
              paddingTop:'20px'
            }}
          >
            {errorMsg}
          </Typography>
        </>
      }
      {/* Popup che appare dopo il salvataggio */}
      <Snackbar open={showPopup} anchorOrigin={{vertical: 'bottom', horizontal: "right" }}>
        <Alert severity="success"
          sx={{ 
            border: '2px solid green',
            marginBottom:'30px'
          }}
          onClose={() => setShowPopup(false)}>
          {t("Cambio Password avvenuto con successo")}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default ChangePassword;
